module.exports = __webpack_public_path__ + "static/media/personal-gps-tracker-2.e2e7ff81.jpg";